import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
const pickupCarousel = () => {
  let pickup_slide = $('.pickup__carousel');
  pickup_slide.slick({
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    pauseOnHover: false,
    centerMode: true,
    centerPadding: '0',
    focusOnSelect: true,
    infinite: true,
    appendDots: $('.btn-carousel .--dots'),
    prevArrow: $('.--prev'),
    nextArrow: $('.--next'),
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          arrows: false
        }
      }
    ]
  });
  $('.--prev').hide();
  pickup_slide.on('afterChange', function (event, slick, currentSlide) {
    if (currentSlide === 0) {
      $('.--prev').hide();
      $('.--next').show();
    }
    else {
      $('.--prev').show();
    }
    // if (slick.slideCount === currentSlide + 1) {
    //   $('.--next').hide();
    // }
  });
}

const articleCarousel = () => {
  let article_slide = $('.article.--carousel');
  article_slide.slick({
    autoplay: false,
    autoplaySpeed: 5000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    pauseOnHover: false,
    centerMode: true,
    centerPadding: '0',
    focusOnSelect: true
  });
}

export { pickupCarousel, articleCarousel }
